import React, { FC } from "react";
import Modal, { ModalController } from "Components/Modal/Modal";
import { useTranslation } from "Providers/TranslationProvider";
import { DialogContent } from "@material-ui/core";
import ModalTitle from "Components/Modal/ModalTitle";
import OrganizationSuggestionForm from "./OrganizationSuggestionForm";

interface Props {
  modalController: ModalController<unknown>;
}

const OrganizationSuggestionModal: FC<Props> = (props) => {
  const { t } = useTranslation();

  if (props.modalController.isOpen) {
    return (
      <Modal
        // pagePath={TrackingPage.AUTH_SIGN_OUT}
        modalController={props.modalController}
      >
        <ModalTitle
          close={props.modalController.close}
          title={t("OrganizationSuggestionModal_Title")}
        />
        <DialogContent>
          <OrganizationSuggestionForm close={props.modalController.close} />
        </DialogContent>
      </Modal>
    );
  } else {
    return null;
  }
};

export default OrganizationSuggestionModal;
